import { setCookie } from "@utils/setCookie.js";
import type { Currency } from "@core/schema/Currency.js";
import { currencyCookieName } from "../currencyCookieName.js";

export const selectedCurrency = new (class SelectedCurrency {
	private _current = $state<Currency>();

	public get current(): Currency | undefined {
		return this._current;
	}

	public initialize(currency: Currency | undefined): void {
		this._current = currency;
	}

	public async select(currency: Currency): Promise<void> {
		this._current = currency;
		await setCookie(currencyCookieName, currency);
	}
})();
